<template>
  <div class="setting-view common-view content-view">
    <common-header/>

    <div class="container">
      <h1 class="main-title">{{`Team ‘${user.team['team-name']}’`}}</h1>

      <div class="title">MANAGER</div>

      <!-- <team-member :model="manager" :onChange="openManager"/> -->
      <team-member :model="user" :email="user.email" :renewalDate="user.team['renewal-date']"/>

      <br>
      <br>

      <div class="title">MEMBERS ({{teamMembers.length}})</div>

      <team-member v-for="(item, index) in teamMembers" :key="item.id" :model="item" :email="item.email" :renewalDate="user.team['renewal-date']" :onDelete="openDelete(index)"/>

      <a class="add link-inverse" @click="openAdd">Add a new member</a>
    </div>

    <modal-team-manager :active="showManager" :onSubmit="handleManager" :onClose="handleClose"/>

    <modal-team-delete :active="showDelete" :onSubmit="handleDelete" :onClose="handleClose"/>

    <modal-team-add :active="showAdd" :onSubmit="handleAdd" :onClose="handleClose"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ModalTeamAdd from '../components/team/ModalTeamAdd';
import ModalTeamDelete from '../components/team/ModalTeamDelete';
import ModalTeamManager from '../components/team/ModalTeamManager';
import CommonHeader from './CommonHeader';
import TeamMember from '../components/team/TeamMember';
import { sendRequest } from '../utils/api';
import { getSession } from '../utils/session';
// import router from '../router';

export default {
  components: {
    ModalTeamAdd,
    ModalTeamManager,
    ModalTeamDelete,
    TeamMember,
    CommonHeader,
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
  },
  data() {
    return {
      showManager: false,
      showDelete: false,
      showAdd: false,
      deleting: 0,
      teamMembers: [],
    };
  },
  created() {
    sendRequest(`/users/get_members/${this.user.team['team-id']}`, 'get', { Authorization: getSession('jwtoken') }, {})
      .then((response) => {
        this.teamMembers = response.data.users;
      })
      .catch(err => console.log(err));
  },
  methods: {
    ...mapActions('notification', [
      'addNotification',
    ]),
    handleClose() {
      this.showManager = false;
      this.showDelete = false;
      this.showAdd = false;
    },
    openManager() {
      this.showManager = true;
    },
    openDelete(index) {
      return () => {
        this.deleting = index;
        this.showDelete = true;
      };
    },
    openAdd() {
      this.showAdd = true;
    },
    handleManager(item) {
      this.manager = item;
      this.handleClose();
    },
    handleDelete() {
      sendRequest(
        `/users/remove_member/${this.user.team['team-id']}/${this.teamMembers[this.deleting]['user-id']}`,
        'delete',
        { Authorization: getSession('jwtoken') },
        {},
      )
        .then(() => {
          this.teamMembers.splice(this.deleting, 1);
          this.handleClose();
        })
        .catch((err) => {
          console.log(err);
          this.handleClose();
        });
    },
    handleAdd(items) {
      sendRequest(
        `/users/add_member/${this.user.team['team-id']}`,
        'post',
        { Authorization: getSession('jwtoken') },
        {
          email: items.map(item => item.email),
        },
      )
        .then(() => {})
        .catch(() => {});
      this.addNotification({ message: 'Invitations have been sent successfully!' });
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
  .title {
    font-size: 14px;
    font-weight: bold;
    opacity: .3;
    margin-bottom: 15px;
  }

  .add {
    font-weight: bold;
  }
</style>
